import { UserData } from '@/common/types/users'
import Box from '../Box'
import { LockKeyholeIcon } from 'lucide-react'

interface OAuthProviderFieldProps {
  user?: UserData | null
}

const OAuthProviderField = ({ user }: OAuthProviderFieldProps) => {
  if (user?.authentication_method !== 'oauth' || !user.oauth_provider) return null

  return (
    <Box className='py-1 px-4 h-[52px] w-1/3 bg-white-200 rounded-md flex items-center gap-2'>
      <LockKeyholeIcon strokeWidth={1.5} size={16} />

      <p className='text-xs'>
        Autenticação vinculada
      </p>

      {user.oauth_provider === 'google' && <img src='/Google.svg' className='size-4' />}
    </Box>
  )
}

export default OAuthProviderField;
